import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { GoogleAuthService } from '../../services/google-auth.service';

// Renders a Google-branded sign-in button that follows Google's visual identity guidelines.
// Clicking it triggers the OAuth2 redirect flow via GoogleAuthService.
@Component({
  selector: 'app-google-signin-button',
  standalone: true,
  imports: [TranslocoModule],
  styles: [`
    .google-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      padding: 10px 16px;
      border: 1px solid #dadce0;
      border-radius: 4px;
      background: #fff;
      cursor: pointer;
      font-family: 'Google Sans', Roboto, Arial, sans-serif;
      font-size: 14px;
      font-weight: 500;
      color: #3c4043;
      letter-spacing: 0.25px;
      transition: background 0.2s, box-shadow 0.2s;
    }
    .google-btn:hover {
      background: #f8f9fa;
      box-shadow: 0 1px 3px rgba(0,0,0,.2);
    }
  `],
  template: `
    <div style="display:flex;justify-content:center">
      <button class="google-btn" type="button" (click)="onClick()">
        <!-- Google 'G' logo stored as a static asset instead of inline SVG to keep the template clean. -->
        <img src="/assets/icons/google-logo.svg" width="18" height="18" alt="">
        <!-- Button label translated via Transloco; key 'signup.continue.with.google' exists in all 8 supported languages. -->
        {{ 'signup.continue.with.google' | transloco }}
      </button>
    </div>
  `
})
export class GoogleSignInButtonComponent {
  private readonly googleAuthService = inject(GoogleAuthService);

  onClick(): void {
    this.googleAuthService.initiateRedirect();
  }
}
